import { MacroCategorySelector } from "./macro-category-selector"

export function MacroCategoryFilters({ categories = [], selectedCategories = [], onChangeCategories }) {
    if (!categories.length && !selectedCategories.length) return null

    return (
        <MacroCategorySelector
            categories={categories}
            selectedCategories={selectedCategories}
            onChange={handleChange}
            label=""
            placeholder="Filter by category"
        />
    )

    function handleChange(nextValues) {
        if (!onChangeCategories) return
        onChangeCategories(nextValues)
    }
}
